<app-page-content>
<app-doenkids-menu-bar menuBar>
  <div left>
    <div class="search-wrapper">
      @if (!(showMobileSearchBar$ | async)) {
        <div class="search">
          <mat-icon>search</mat-icon>
          <input matInput [placeholder]="'activity_overview.search.placeholder' | translate" [formControl]="searchControl" (keydown.enter)="advancedSearch()" />
        </div>
      }
      <button class="extended-search-button" mat-button (click)="advancedSearch()">
        {{ 'activity_overview.search.label' | translate }}
        <mat-icon>arrow_right</mat-icon>
      </button>
    </div>
  </div>
</app-doenkids-menu-bar>
<div content>
@if (showMobileSearchBar$ | async) {
<div class="mobile-search-bar">
  <div class="search">
    <mat-icon>search</mat-icon>
    <input matInput [placeholder]="'activity_overview.search.placeholder' | translate" [formControl]="searchControl" (keydown.enter)="advancedSearch()" />
  </div>
</div>
}

<div class="page-container" #pageContainer>
  <div class="activities-for-review">
    @if ((isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) { @if (countNumber$ | async; as countValue) { @if
    (countValue > 0) {
    <a (click)="goToActivitiesToReview()" mat-flat-button>{{ 'activity.review.count' | translate : { countValue } }}</a>
    } } }
  </div>

  @for (activitySection of activitySections$ | async; track activitySection) { @if (!activitySection.isOptional || activitySection.activities.length > 0) {
  <h2 class="row-title default-cursor">
    {{ activitySection.translationKey | translate }}
  </h2>
  <div [ngClass]="['activity-row', activitySection.name]">
    @if (activitySection.activities.length > 0) {
    <swiper-container class="swiper-container" class="flex-auto" dkSwiper [config]="swiperConfig" init="false">
      @for (activity of activitySection.activities; track activity; let i = $index) {
      <swiper-slide
        [ngClass]="['zoom-box', activitySection.name === 'top-10' ? 'top-10-item' : 'activity-item']"
      >
        @if (activitySection.name === 'top-10') {
        <span
          class="number"
          aria-hidden="true"
        >{{ getTopNumber(i) }}</span>
        }
        <div class="activity" (click)="goToActivityPreview(activity)">
          <app-doenkids-image [mediaItem]="{ uuid: activity.media_uuid, description: '' }" [preview]="true" previewVariant="medium"></app-doenkids-image>
          <div class="content">
            <h3 class="title">{{ activity.name }}</h3>
          </div>
        </div>
      </swiper-slide>
      } @if (activitySection.isSearchable) {
      <swiper-slide class="see-more-card" (click)="activityKindSearch(activitySection.activityKindName)">
        <span>
          {{
            'activity_overview.see_more'
              | translate
                : {
                    activityKindName:
                      activitySection.name === 'all'
                        ? undefined
                        : (activitySection.translationKey + activitySection.seeMoreTranslationKeySuffix | translate | lowercase)
                  }
          }}
        </span>
      </swiper-slide>
      }
    </swiper-container>
    } @else { @if (loaded$ | async) {
    <div matTooltipPosition="right" [matTooltip]="'activity_overview.no_results.tooltip' | translate" class="activity not-found">
      <img [src]="activity404Image" [alt]="'activity_overview.no_results.alt' | translate" />
    </div>
    } @if (!(loaded$ | async)) {
    <div [matTooltip]="'activity_overview.no_results.tooltip' | translate" class="activity not-found">
      <mat-spinner [diameter]="32" class="spinner"></mat-spinner>
    </div>
    } }
  </div>
  } }

</div>
</div>
</app-page-content>
